export default __webpack_public_path__ + "3e29d3e531a2a7bd911916439622105b.png";